import React from 'react';
import CreateDatasheet from './CreateDatasheet';
import { AuthProvider, ProductsProvider } from 'contexts';

const styles = {
  layout: {
    display: 'flex',
    width: '100%',
  },
};

export default () => {
  return (
    <AuthProvider>
      <ProductsProvider>
        <div style={styles.layout}>
          <CreateDatasheet/>
        </div>
      </ProductsProvider>
    </AuthProvider>
  );
};
